var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: {
      pageName: _vm.$t("ProjectManagement") + " / " + _vm.$t("Directory")
    },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function() {
          return [
            _c("TableView", {
              attrs: { selectedItem: _vm.selectedWorkspace },
              on: {
                "open-create-workspace-form": function($event) {
                  _vm.selectedWorkspace = {}
                },
                "clear-selected-item": function($event) {
                  _vm.selectedWorkspace = null
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "right",
        fn: function() {
          return [
            _c("Workspace", {
              attrs: { selectedWorkspace: _vm.selectedWorkspace },
              on: {
                "clear-selected-item": function($event) {
                  _vm.selectedWorkspace = null
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ad66de8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ad66de8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DirectoryView.vue
// module id = null
// module chunks = 